const sanitizeFilterValue = <T = string>(
  value: string,
  options: T[],
): T | undefined => {
  const val = value as T;
  if (options.includes(val as T)) {
    return val;
  }
  return undefined;
};
export default sanitizeFilterValue;
